import { PhysicalCardShipping } from 'redux/employeePlatform/employeePlatformTypes'

type CardLike = { type?: string }

type BillingAddress = {
  city?: string | null
  country?: string | null
  line1?: string | null
  line2?: string | null
  postalCode?: string | null
  state?: string | null
} | null

export function shouldShowRequestPhysicalCardButton({
  employerAllowsRequest,
  cards,
  alreadyRequested,
}: {
  employerAllowsRequest: boolean | null | undefined
  cards: CardLike[] | null | undefined
  alreadyRequested: boolean
}): boolean {
  if (employerAllowsRequest === false || alreadyRequested) return false
  if (!cards || cards.length === 0) return false
  return cards.every((card) => card.type !== 'physical')
}

export function physicalCardShippingFromBilling(
  billing: BillingAddress | undefined
): PhysicalCardShipping | null {
  if (!billing) return null
  const entries = Object.entries({
    city: billing.city,
    country: billing.country,
    line1: billing.line1,
    line2: billing.line2,
    postalCode: billing.postalCode,
    state: billing.state,
  }).filter(([, value]) => typeof value === 'string' && value.trim() !== '')
  const shipping = Object.fromEntries(entries) as PhysicalCardShipping
  if (!shipping.line1) return null
  return shipping
}
